// pages/admin/TournamentsList.tsx
import { useEffect, useState } from "react";
import { Container, Row, Col, Table,  Modal, Button, Form } from "react-bootstrap";
import { apiService } from "../../service/api.service";
import Pagination from "react-js-pagination";
import ExpandableText from "./ExpandableText";
import { ThreeDotSpinner } from "../loader"
export default function TournamentsList() {
  const [tournaments, setTournaments] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorName, seterrorName] = useState(null);
  const [errorDesc, seterrorDesc] = useState(null);
  const [errorField, seterrorField] = useState(null);
  const [name, setName] = useState('');
  const [loader, setLoader]=useState(false)
  const [description, setDescription] = useState('');
  const [page, setPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
 
  // Create modal (simple inline) — can swap to your existing modal if you have one
  const [modalShow, setModalShow] = useState(false);
  function handlePageChange(pageNumber) {
    setPage(pageNumber);
    fetchTournaments(pageNumber);
};


  async function fetchTournaments(page) {
    try {
    
      setLoader(true)
      setError(null);
      const res = await apiService.getTournament(page)
      setTournaments(res.data.data || []);
      settotalCount(res.data.total)
     } catch (e) {
     setError(e.message || "Failed to load tournaments");
    } finally {
      setLoader(false);
    }
  }

  async function onClose() {
    setModalShow(false)
  }
  async function createTournament(e) {
    e.preventDefault();
    seterrorField(null);
    seterrorName(null);
    seterrorDesc(null);
    try {
   
      let data = { name: name.trim(), description:description }
      if(!name && name.trim()==""){
        seterrorName("Tournament name is required")
        return
      }
      if(!description && description.trim()==""){
        seterrorDesc("Tournament description is required")
        return
      }
      setLoader(true)
      const r = await apiService.addTournament(data)
      console.log("====r===",r)

       if(r.status==201){
       setLoader(false)
      setModalShow(false);
      setName("")
      setDescription("")
      setPage(1)
      fetchTournaments(page);
       }
    } catch (e) {
      setLoader(false)
    
      seterrorField(e.response?.data?.message || "Failed to create");
    }
  }

  useEffect(() => {
    setPage(1)
    fetchTournaments(1);
  }, []);

  return (
    <div className="dashboard-main-area">
              {loader == true ? <ThreeDotSpinner /> : ""}
      <Container fluid>
        <div className="dashboard-area-heading management-heading">
          <Row className="row justify-content-center align-items-center mb-3">
            <Col md={12} lg={11}>
              <div className="heading-top-area">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="align-self-center m-0">Tournaments</h2>

                   <div className="heading-top-area-right">
                                      <div className="export-csv-btn add-btn-area me-2">
                                        <Button
                                          type="button"
                                          variant="unset"
                                          onClick={() => setModalShow(true)}
                                        >
                                          <i class="fa fa-plus" aria-hidden="true"></i> Create Tournament
                                        </Button>
                                      </div>
                                      </div>
            
                </div>
              </div>
            </Col>
          </Row>

          <Row className="pb-4 justify-content-center">
            <Col md={12} lg={11}>
              <div className="availabilit-section">
              {error && <div className="text-danger mb-2">{error}</div>}
                <Table responsive="sm" className="UserListTable">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Name</th>
                      <th>Description</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <tr>
                        <td colSpan={4}>Loading…</td>
                      </tr>
                    ) : tournaments.length === 0 ? (
                      <tr>
                        <td colSpan={4}>No tournaments yet.</td>
                      </tr>
                    ) : (
                      tournaments.map((t, index) => (
                        <tr key={t._id}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="d-flex flex-column">
                              <span className="fw-semibold">{t.name}</span>
                         
                            </div>
                          </td>
                          <td>
                            <td>
                           
                            {t.description ? (
          <ExpandableText
            text={t.description}
            charLimit={50}  // show "View more" if > 140 chars
            breakEvery={28}  // force a wrap opportunity every ~28 chars
            className="fw-semibold"
          />
        ) : null}
                            {/* {t.description ? (
                                <span className="fw-semibold">{t.description}</span>
                              ) : null} */}
                            </td>
                            {/* Public explore filtered by username (adjust to your actual route/query) */}
                         
                          </td>
                        
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>


               
              </div>
              {tournaments && totalCount && totalCount > 10 ? (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={10}
                                        totalItemsCount={totalCount}
                                        pageRangeDisplayed={5}
                                        onChange={(e) => handlePageChange(e)}
                                        prevPageText={"Prev"}
                                        nextPageText={"Next"}
                                    />
                                ) : null}
            </Col>
          </Row>
        </div>
      </Container>

      {/* Lightweight Create modal */}
      <Modal show={modalShow} onHide={onClose} centered>
      <Modal.Header closeButton><Modal.Title>Create Tournament</Modal.Title></Modal.Header>
      <Modal.Body>
      {errorField && <div className="text-danger mb-2">{errorField}</div>}
        <Form.Group className="mb-3">
          <Form.Label>Tournament name (also Username)</Form.Label>
          <Form.Control value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. tushar" />
          {errorName && <div className="text-danger mb-2">{errorName}</div>}
        </Form.Group>
        <Form.Group>
          <Form.Label>Description</Form.Label>
          <Form.Control as="textarea" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
          {errorDesc && <div className="text-danger mb-2">{errorDesc}</div>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={createTournament}>Create</Button>
      </Modal.Footer>
    </Modal>
    </div>
  );
}
